import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {

return originalPush.call(this, location).catch(err => err)

}

export const routes = [
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/login.vue'),
    hidden: true,
    meta: {
      requireAuth: false
    },
  },
  {
    path: '/login1',
    name: '登录1',
    component: () => import('../views/login1.vue'),
    hidden: true,
    meta: {
      requireAuth: false
    },
  },
  {
    path: '/',
    component: Home,
    redirect: '/index',
    children: [{
      path: '/index',
      name: 'index',
      component: () => import('../views/index.vue'),
      meta: {
        requireAuth: true,
        title:"首页"
      }
    },
    {
      path: '/infoPage/userCenter',
      name: 'userCenter',
      component: () => import('../views/infoPage/userCenter.vue'),
      meta: {
        requireAuth: true
      }
    },
  
  ]
  },
 
 
 
]


// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const createRouter = () => new VueRouter({
 
  // base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  routes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
